import React from "react"
import Link from "gatsby-link"
import Helmet from "react-helmet"

import Navigation from '../layouts/navigation.js'
import Footer from '../layouts/footer.js'

import Slider from '../layouts/slider.js'

import Collapse, { Panel } from "rc-collapse";

import { AreaChart, Area, XAxis, YAxis, CartesianGrid, ResponsiveContainer } from 'recharts';

import europe_character from '../img/subdomen/europe_character_home.svg'
import europe_flags from '../img/subdomen/europe_flags.svg'
import explore_opportunities from '../img/subdomen/europe_explore-opportunities.svg'

import review_logo from '../img/review-logo.svg'
import trustpilot from '../img/trustpilot-logo.svg'
import current_projects from '../img/current-projects.svg'
import register_now from '../img/register-now.svg'

import ogp_cover from '../img/cover.png'

export default class Index extends React.Component {

	constructor() {
		super();

		this.state = { 
			average: '',
			averageOrders: '',
			dataGraph: [],
			totalNumberOfReviews: '',
			trustScore: '',
			currentRatingWord:'',
			ratingWord: '',
			ratingListWord: [ 
				"Bad",
				"Poor",
				"Average",
				"Great",
				"Excellent"
			]
		}

	}

	pageClick(e) {
		document.getElementsByTagName('body')[0].className=''
	}

	componentDidMount() {
		const self = this;
	    var mask = document.getElementById('mask');
	    mask.addEventListener('touchstart', this.pageClick, false);

		if(!document.getElementById('available_total')) {
			window.logIt = function(data) {
				self.setState({average: data.avg});
				self.setState({averageOrders: data.count});
			}.bind(self);
			 
			(function (d, s, id) {
				var js, fjs = d.getElementsByTagName(s)[0];
				if (d.getElementById(id)) return;
				js = d.createElement(s); js.id = id;
				js.src = process.env.GATSBY_API_URL+'/api/orders/available/total?callback=logIt&jsonp=true';
				fjs.parentNode.insertBefore(js, fjs);
			}(document, 'script', 'available_total'));
		}

		if(!document.getElementById('trustpilot_widget')) {
			window.trustpilot = function(data) {
				self.setState({totalNumberOfReviews: data.ratingsTotalCount});
				self.setState({trustScore: data.trustScore});

				self.setState({currentRatingWord: Math.ceil((data.trustScore * 5) / 5)});
				self.setState({ratingWord: self.state.ratingListWord[self.state.currentRatingWord-1]});
			}.bind(self);
			 
			(function (d, s, id) {
				var js, fjs = d.getElementsByTagName(s)[0];
				if (d.getElementById(id)) return;
				js = d.createElement(s); js.id = id;
				js.src = process.env.GATSBY_API_URL+'/api/trustpilot/54229a4300006400057a8430?callback=trustpilot&jsonp=true';
				fjs.parentNode.insertBefore(js, fjs);
			}(document, 'script', 'trustpilot_widget'));
		}

		self.setState({ dataGraph :[ { name: '2007', uv: 164 }, { name: '2008', uv: 241 }, { name: '2009', uv: 648 }, { name: '2010', uv: 548 }, { name: '2011', uv: 585 }, { name: '2012', uv: 837 }, { name: '2013', uv: 1072 }, { name: '2014', uv: 1092 }, { name: '2015', uv: 1469 }, { name: '2016', uv: 1429 }, { name: '2017', uv: 1589 },]});
	}

	componentWillUnmount() {
		var totalId = document.getElementById('available_total'), trustpilot_widget = document.getElementById('trustpilot_widget');
		totalId.parentNode.removeChild(totalId);
		trustpilot_widget.parentNode.removeChild(trustpilot_widget);
	}


	render() {
		return (
			<div>

				<Helmet
					title="Freelance Writing Jobs. Academic Writing Jobs - Europe.UvoCorp.com"
					meta={[
						{ name: "description", content: "Want a job that will help you stay mobile even in your hometown? Do you know English really well or is it actually your mother language? Become a freelance academic writer with our company" },

						{ property: 'og:title', content: "Freelance Writing Jobs. Academic Writing Jobs - Europe.UvoCorp.com" },
						{ property: 'og:description', content: "Want a job that will help you stay mobile even in your hometown? Do you know English really well or is it actually your mother language? Become a freelance academic writer with our company" },
						{ property: 'og:site_name', content: "Europe.UvoCorp.com" },
						{ property: 'og:type', content: "website" },
						{ property: 'og:image', content: ogp_cover },
					]}
					link={[
						{ rel: 'canonical', href: "https://europe.uvocorp.com/" },
						{ rel: 'alternate', href: "https://www.uvocorp.com", hrefLang: "en" },
						{ rel: 'alternate', href: "https://canada.uvocorp.com", hrefLang: "en-ca" },
						{ rel: 'alternate', href: "https://hongkong.uvocorp.com", hrefLang: "en-hk" },
						{ rel: 'alternate', href: "https://india.uvocorp.com", hrefLang: "en-in" },
						{ rel: 'alternate', href: "https://nigeria.uvocorp.com", hrefLang: "en-ng" },
						{ rel: 'alternate', href: "https://pakistan.uvocorp.com", hrefLang: "en-pk" },
						{ rel: 'alternate', href: "https://philippines.uvocorp.com", hrefLang: "en-ph" },

						{ rel: 'alternate', href: "https://europe.uvocorp.com", hrefLang: "en-pl" },
						{ rel: 'alternate', href: "https://europe.uvocorp.com", hrefLang: "en-ro" },
						{ rel: 'alternate', href: "https://europe.uvocorp.com", hrefLang: "en-bg" },
						{ rel: 'alternate', href: "https://europe.uvocorp.com", hrefLang: "en-md" },
						{ rel: 'alternate', href: "https://europe.uvocorp.com", hrefLang: "en-ua" },
					]} />

				<div className="home-navigation">
					<div className='header' id="header">
					
						<Navigation />
					
					</div>
				</div>

				<div className="wrapper subdomen">

					<div className="home-header">
						<div className="container">
							<div className="home-header-image">
								<div className="img home-header-img">
									<img id="home-header-img" src={europe_character} />
								</div>
							</div>
							<div className="home-header-text">
								<div className="home-header-title">Register now to start earning!</div>
								<div className="home-header-subtitle">UVOCORP is a freelance academic writing agency, which could offer you the perfect job!</div>
								<div className="home-header-button">
									<a href={`${process.env.GATSBY_API_URL}/register_email.html`}>Register now</a>
								</div>
							</div>
						</div>
					</div>

					<div className="home-block home-block-gray home-header-seo-cols">
						<div className="container">
							<div className="row">
								<div className="col-sm-6">
									<p>Modern day technology allows us to be more mobile in all areas of life, including work. Want a job that will help you stay mobile even in your hometown? Do you know English really well or is it actually your mother language? Become a freelance academic writer with our company.</p>
									<p>Part-time or a full-time schedule. You decide which best meets your needs, what is more convenient for you, and how much time you can afford to commit to writing. It’s simple.</p>
								</div>
								<div className="col-sm-6">
									<p>Just register and send us a sample paper for evaluation. We will notify you of the results as soon as possible.</p>
									<p>If you like traveling, now that it has become easier to travel around Europe, freelance writing jobs are more relevant than ever. You can change your location and do what you like without changing your job. Write amazing academic papers and see cool places, as well.</p>
								</div>
							</div>
						</div>
					</div>

					<div className="home-pricing-info">
						<div className="container">
							<p>There is no other company that offers <strong>$15</strong>/page written by an <span className="home-pricing-info-role">ESL</span> writer and <strong>$26</strong>/page completed by an <span className="home-pricing-info-role">ENL</span> writer.</p>
							<a href={`${process.env.GATSBY_API_URL}/prices.html`}>View Pricing <svg id="arrow-right" width="22" height="22"><path fill="#black" d="M17.2,10.2l-3.2,3c-0.1,0.1-0.2,0.1-0.3,0c-0.1,0-0.2-0.1-0.2-0.2v-1.9H3c-0.2,0-0.3-0.1-0.3-0.3V9.2 C2.8,9,2.9,8.9,3,8.9h10.5V7.1c0-0.1,0.1-0.2,0.2-0.2c0.1,0,0.2,0,0.3,0l3.2,2.9c0.1,0.1,0.1,0.1,0.1,0.2 C17.2,10.1,17.2,10.1,17.2,10.2z"/></svg></a>
						</div>
					</div>

					<div className="home-block home-seo-cols">
						<div className="container">
							<h2>Benefits of a Freelance Writing Career</h2>
							<div className="row">
								<div className="col-sm-6">
									<p>There are a number of benefits freelancing gives you right away, as well as long term. Aside from the most obvious ones, like freedom of choosing your own working hours and workplace location, you can also practice and acquire soft skills (time-management, planning, communication, etc.). You might even discover new techniques that are useful in freelance writing.</p>
									<p>In academic writing, your skills, knowledge of citation formats, and standards of writing certain types of papers are what matter the most. And, of course, English. Knowledge of English grammar and style, as well as common phrases, are an important consideration in being invited to join our team. Although it is always a plus, having prior experience on any kind of job is not a requirement for employment with us</p>
									<p>Our job offer should be especially interesting to people who have just acquired college degrees.</p>
								</div>
								<div className="col-sm-6">
									<p>Many students need help with homework, and most homework is about writing papers. That is, you don’t have to worry about finding work options here. Some students even study during the summer, so you can be sure there is a constant influx of orders, with certain periods of high activity.</p>
									<p>We have all the tools you need to manage orders and work efficiently. You choose the orders you wish to complete, and the price stated with the order is exactly what you will receive for payment. Prices are fair and are determined by the deadline and academic level (how complex the writing should be).</p>
									<p>You can communicate with customers via messaging to clarify anything you need to know about the order before or after you apply for it. You can also contact Support Team via chat, phone or email in case of any issues with the order.</p>
								</div>
							</div>
						</div>
					</div>

					<div className="home-benefits home-block-gray">
						<div className="container">
							<h1>The benefits you enjoy working as a freelance writer:</h1>
							<ul className="home-benefits-list">
								<li className="home-benefits-1">
									<p>No registration fees</p>
								</li>
								<li className="home-benefits-2">
									<p>High wages</p>
								</li>
								<li className="home-benefits-3">
									<p>Working from home</p>
								</li>
								<li className="home-benefits-4">
									<p>Orders in the sphere <br />of your interest</p>
								</li>
								<li className="home-benefits-5">
									<p>24/7 available <br />support team</p>
								</li>
								<li className="home-benefits-6">
									<p>Payments always <br />on time</p>
								</li>
								<li className="home-benefits-7">
									<p>Manage your time <br />and workload yourself</p>
								</li>
							</ul>
						</div>
					</div>

					<div className="home-block">
						<div className="container">
							<h2>Countries of writers already working with us:</h2>
							<div className="home-flags">
								<div className="home-flags-animation">
									<img src={europe_flags} alt="Countries of writers 1"/>
									<img src={europe_flags} alt="Countries of writers 2"/>
								</div>
							</div>
						</div>
					</div>

					<div className="home-block-gray home-block-gray-calltoaction">
						<div className="container">
							<p>
								You are an applicant and have questions? We will help you! 
								<a href={`${process.env.GATSBY_API_URL}/contacts.html`} className="chat">
									Contact Us
								</a>
							</p>
						</div>
					</div>

					<div className="home-block">
						<div className="container">
							<div className="row">
								<div className="col-md-push-5 col-md-7">
									<h2 className="left home-graph-h2">Who we are </h2>
									<p><a href={`${process.env.GATSBY_API_URL}/about.html`}>UVOCORP</a> is a reliable partner for professional freelance writers who are looking for a trustworthy <a href={`${process.env.GATSBY_API_URL}/hiring.html`}>long-term cooperation</a>. For those pursuing personal development, our company is also the right choice since we offer numerous interesting projects and opportunities for self-improvement. Besides, our support team members are always ready to help as they work 24/7.</p>
									<p className="home-block-regular">If writing is what you like, you are welcome to give it a try with us!</p>
								</div>
								<div className="col-md-pull-7 col-md-5 ">
									<div className="home-graph-title">Quantitative growth of writers</div>
									<div className="home-graph-date">March 2007 - November 2017</div>
									<div className="home-graph1">
										<ResponsiveContainer minHeight={250}>
											<AreaChart data={this.state.dataGraph} margin={{ top: 10, right: 15, left: 15, bottom: 0 }}>
												<defs>
													<linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
														<stop offset="5%" stopColor="#f29f22" stopOpacity={0.8} />
														<stop offset="95%" stopColor="#f29f22" stopOpacity={0} />
													</linearGradient>
												</defs>
												<XAxis dataKey="name" interval={0} tick={{fontSize: '11px'}} />
												<YAxis hide={true} />
												<CartesianGrid strokeDasharray="8 8" vertical={false} />
												<Area type='linear' dataKey='uv' stroke='#f29f22' fillOpacity={1} fill="url(#colorUv)" dot={{ r: 4, stroke: '#fff', fill: '#f29f22', strokeWidth: 1.5, fillOpacity: 100 }} />
											</AreaChart>
										</ResponsiveContainer>
									</div>
									<p className="home-graph-text"><span className="home-teal-color">327 writers</span> are working with us for <span className="home-teal-color">more than 3 years</span></p>
								</div>
							</div>
						</div>
					</div>


					<div className="home-block home-block-gray">
						<div className="container">
							<h2>Explore Opportunities</h2>
							<div className="row">
								<div className="col-md-6">
									<p>We are very flexible in terms of what working conditions you wish to select. If you need part-time employment, extra cash to pay the bills, rent, or just for fun, options are available.</p>
									<p>If you want to dedicate your whole working day to writing academic papers, that is also possible. In addition, you have the option to choose more than just your major discipline. Utilize your knowledge and explore new horizons.</p>
									<p>If writing is on the top of your list of favorite activities and you are good at it, we welcome you with open arms.</p>
								</div>
								<div className="col-md-6">
									<div className="home-block-img">
										<img src={explore_opportunities} alt="Explore Opportunities"/>
									</div>
								</div>
							</div>
						</div>
					</div>


					<div className="home-block">
						<div className="container">
							<h2>Current projects offered</h2>
							<div className="row">
								<div className="col-sm-6">
									<div className="home-block-img">
										<img src={current_projects} alt="Current projects offered"/>
									</div>
								</div>
								<div className="col-sm-6 home-current-projects-text">
									<p>Average order price: <strong className="home-teal-color">${this.state.average}</strong></p>
									<p>Currently available orders: <strong className="home-teal-color">{this.state.averageOrders}</strong></p>
									<p className="home-current-projects-link"><a href={`${process.env.GATSBY_API_URL}/view_all_orders.html`}>View all orders <svg id="arrow-right" width="22" height="22"><path fill="#f29f22" d="M17.2,10.2l-3.2,3c-0.1,0.1-0.2,0.1-0.3,0c-0.1,0-0.2-0.1-0.2-0.2v-1.9H3c-0.2,0-0.3-0.1-0.3-0.3V9.2 C2.8,9,2.9,8.9,3,8.9h10.5V7.1c0-0.1,0.1-0.2,0.2-0.2c0.1,0,0.2,0,0.3,0l3.2,2.9c0.1,0.1,0.1,0.1,0.1,0.2 C17.2,10.1,17.2,10.1,17.2,10.2z"/></svg></a></p>
								</div>
							</div>
						</div>
					</div>

					<div className="home-block-gray home-block-gray-calltoaction">
						<div className="container">
							<p>Do you want to see the full pricing policy? <a href={`${process.env.GATSBY_API_URL}/prices.html`}>Pricing Policy</a></p>
						</div>
					</div>


					<div className="home-block">
						<div className="container">
							<h2>What our writers say</h2>

							<Slider />

							<div className="trast">
								<div className="trast-avatar">
									<img src={review_logo} alt="avatar for trustpilot.com"/>
								</div>
								<div className="trast-info">
									<div className="trast-info-rating-stars">
										<ul className="rating">
											{this.state.trustScore < 1?(
												<li className="rating-empty"></li>
												):(
												<li></li>
											)}
											{this.state.trustScore < 2?(
												<li className="rating-empty"></li>
												):(
												<li></li>
											)}
											{this.state.trustScore < 3?(
												<li className="rating-empty"></li>
												):(
												<li></li>
											)}
											{this.state.trustScore < 4?(
												<li className="rating-empty"></li>
												):(
												<li></li>
											)}
											{this.state.trustScore < 5?(
												<li className="rating-empty"></li>
												):(
												<li></li>
											)}
										</ul>
									</div>
									<div className="trast-info-rating">
										{this.state.ratingWord} {this.state.trustScore} <span className="trast-info-gray">from 0 - 5</span>
									</div>
									<div className="trast-info-based">
										<span className="trast-info-gray">based on {this.state.totalNumberOfReviews} reviews</span>
										<img src={trustpilot} width="106" height="13" alt="trustpilot.com"/>
									</div>
									<div className="trast-info-link">
										<a href="https://www.trustpilot.com/review/uvocorp.com" target="_blank">See more reviews <svg id="arrow-right" width="22" height="22"><path fill="#1164c2" d="M17.2,10.2l-3.2,3c-0.1,0.1-0.2,0.1-0.3,0c-0.1,0-0.2-0.1-0.2-0.2v-1.9H3c-0.2,0-0.3-0.1-0.3-0.3V9.2 C2.8,9,2.9,8.9,3,8.9h10.5V7.1c0-0.1,0.1-0.2,0.2-0.2c0.1,0,0.2,0,0.3,0l3.2,2.9c0.1,0.1,0.1,0.1,0.1,0.2 C17.2,10.1,17.2,10.1,17.2,10.2z"/></svg></a>
									</div>
								</div>
							</div>

						</div>
					</div>

					<div className="home-registration">
						<div className="container">
							<div className="home-registration-text">
								<div className="home-registration-title">Register now <br />to start earning!</div>
								<div className="home-registration-button">
									<a href={`${process.env.GATSBY_API_URL}/register_email.html`}>Start registration</a>
								</div>
							</div>
							<div className="home-registration-image">
								<div className="img home-registration-img">
									<img src={register_now} alt="Start registration"/>
								</div>
							</div>
						</div>
					</div>

					<Footer />

				</div>
				<div id="mask" className="c-mask"></div>

			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/pages/index.js